import LabServiceModel from "@/models/LabServiceModel";
import ScheduleModel from "@/models/lab/ScheduleModel";
import PrepProcess from "@/models/lab/PrepProcessModel";
import ProcessScheduleSampleCollection from "@/collections/lab/ProcessScheduleSampleCollection";
import ProcessScheduleInstrumentInstanceCollection from "@/collections/lab/ProcessScheduleInstrumentInstanceCollection";
import InstrumentInstanceCollection from "@/collections/lab/InstrumentInstanceCollection";
import SampleCollection from "@/collections/lab/SampleCollection";
import InstrumentInstanceScheduleCollection from "../../collections/lab/InstrumentInstanceScheduleCollection";

export default class ProcessScheduleModel extends LabServiceModel {
  modelName() {
    return 'process-schedule';
  }
  routes() {
    const routes = super.routes();
    const route_prefix = `${process.env.VUE_APP_LAB_REPOSITORY_URL}/api/v1/${this.modelName()}`

    routes['downloadList'] = `${route_prefix}/{id}/download-list`;
    routes['uploadList'] = `${route_prefix}/{id}/upload-list`;
    routes['grindingOrder'] = `${route_prefix}/{id}/grinding-order/{instrument_instance_id}`;

    return routes;
  }
  defaults() {
    return {
      id: null,
      schedule_id: null,
      schedulable_process_type: null,
      schedulable_process_id: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      process_schedule_samples: {},
      process_schedule_instrument_instances: {},
      instrument_instance_schedules: {},
      instrument_instances: {},
      samples: {}
    }
  }
  mutations() {
    return {
      id: val => this.nullStringMutator(val),
      schedule_id: val => this.nullStringMutator(val),
      schedulable_process_type: val => this.nullStringMutator(val),
      schedulable_process_id: val => this.nullStringMutator(val),
      created_at: val => this.nullStringMutator(val),
      updated_at: val => this.nullStringMutator(val),
      deleted_at: val => this.nullStringMutator(val),
    }
  }
  validation() {
    return {}
  }
  getSchedule() {
    return this.getRelatedModel(ScheduleModel, 'schedule');
  }
  getSchedulableProcess() {
    return this.getRelatedModel(PrepProcess, 'schedulable_process');
  }
  getProcessScheduleSamples() {
    return this.getRelatedCollection(new ProcessScheduleSampleCollection(), 'process_schedule_samples');
  }
  getProcessScheduleInstrumentInstances() {
    return this.getRelatedCollection(new ProcessScheduleInstrumentInstanceCollection(), 'process_schedule_instrument_instances');
  }
  getInstrumentInstanceSchedules() {
    return this.getRelatedCollection(new InstrumentInstanceScheduleCollection(), 'instrument_instance_schedules');
  }
  getInstrumentInstances() {
    return this.getRelatedCollection(new InstrumentInstanceCollection(), 'instrument_instances');
  }
  getSamples() {
    return this.getRelatedCollection(new SampleCollection(), 'samples');
  }
  downloadList() {
    const method = this.getOption('fetch');
    const route = this.getRoute("downloadList");
    const url = this.getURL(route, { id: this.id });
    
    return this.createRequest({ method, url }).send();
  }

  uploadList(file) {
    const formData = new FormData();
    const route  = this.getRoute('uploadList');
    
    formData.append('file', file);

    const config = {
      method: "POST",
      url: this.getURL(route, { id: this.id }),
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    return this.createRequest(config).send();
  }

  grindingOrder(instrument_instance_id) {
    const method = this.getOption('fetch');
    const route  = this.getRoute('grindingOrder');
    const url = this.getURL(route, {
      id: this.id,
      instrument_instance_id
    });
    
    return this.createRequest({ method, url }).send();
  }

}
